import {
  IonCardHeader,
  IonCardSubtitle,
  IonImg,
  IonText,
} from '@ionic/react';

import BackArrow from '@/assets/imgs/back-arrow.webp';
import PasswordError from '@/assets/imgs/password-error.svg';
import Button from '@/components/common/Button';

import styles from './LoginError.module.scss';

interface LoginErrorProps {
  close: () => void;
  hideHeader?: boolean;
  removeSubtitle?: boolean;
}

export default function LoginError({ close, hideHeader = false, removeSubtitle }: LoginErrorProps) {
  return (
    <>
      {!hideHeader && (
      <IonCardHeader mode="md">
        <IonCardSubtitle className={styles.accessBackPassword}>
          <IonImg
            src={BackArrow}
            className={styles.backArrow}
            onClick={close}
          />
          <IonText
            className="access-back"
            onClick={close}
          >
            Atrás
          </IonText>
        </IonCardSubtitle>
      </IonCardHeader>
      )}
      <div className={styles.infoContainer}>
        <IonImg src={PasswordError} className={styles.recoverImg} />
        <div>
          <IonText className={styles.title} color="dark">
            <h3>¡Ups! Algo está fallando...</h3>
          </IonText>
          {!removeSubtitle && (
          <IonText className={styles.subtitle} color="dark">
            Uno de los datos no es correcto
          </IonText>
          )}
        </div>
        <div className={styles.buttons}>
          <Button
            id="button-setup-biometry-modal-confirm"
            onClick={() => { close(); }}
          >
            Vuelve a intentarlo
          </Button>
          <div className={styles.helpPepper}>
            <p className={styles.helpError}>
              ¿Necesitas ayuda? Ponte en contacto con
              {' '}
              <span>Pepper</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
